import { render } from "./Order-form.vue?vue&type=template&id=0b982bd0&scoped=true"
import script from "./Order-form.vue?vue&type=script&lang=js"
export * from "./Order-form.vue?vue&type=script&lang=js"

import "./Order-form.vue?vue&type=style&index=0&id=0b982bd0&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b982bd0"]])

export default __exports__